/* MY BOB — défilement des photos dans les cartes produits (flèches + balayage, effet glissé) */
(function () {
  'use strict';

  function images(card) {
    try { return JSON.parse(card.getAttribute('data-mb-images') || '[]'); } catch (e) { return []; }
  }

  /* Construit (une seule fois) la bande de photos qui glisse */
  function track(card) {
    var t = card.querySelector('.mb-track');
    if (t) return t;
    var media = card.querySelector('.product-card__media');
    var primary = card.querySelector('.product-card__image--primary');
    if (!media) return null;
    t = document.createElement('div');
    t.className = 'mb-track';
    var cover = primary && primary.classList.contains('object-cover');
    images(card).forEach(function (src) {
      var img = document.createElement('img');
      img.src = src;
      img.alt = '';
      img.draggable = false;
      if (cover) img.className = 'object-cover';
      t.appendChild(img);
    });
    media.appendChild(t);
    return t;
  }

  function go(card, i, animate) {
    var imgs = images(card);
    if (imgs.length < 2) return;
    var t = track(card);
    if (!t) return;
    i = (i + imgs.length) % imgs.length;
    card.setAttribute('data-mb-index', i);
    card.setAttribute('data-mb-active', '');
    t.style.transition = animate ? '' : 'none';
    t.style.transform = 'translateX(' + (-100 * i) + '%)';
    if (!animate) { void t.offsetWidth; t.style.transition = ''; }
  }

  function current(card) {
    return parseInt(card.getAttribute('data-mb-index') || '0', 10);
  }

  function reset(card) {
    card.removeAttribute('data-mb-active');
    card.setAttribute('data-mb-index', '0');
  }

  /* Index affiché au survol : la 2e photo si le thème l'affiche au survol, sinon la 1re */
  function hoverIndex(card) {
    return card.querySelector('.product-card__image--secondary') ? 1 : 0;
  }

  /* Flèches */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.mb-card-arrow');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var card = btn.closest('.mb-card');
    if (!card) return;
    var from = card.hasAttribute('data-mb-active') ? current(card) : hoverIndex(card);
    if (!card.hasAttribute('data-mb-active')) go(card, from, false);
    go(card, from + (btn.classList.contains('mb-card-arrow--prev') ? -1 : 1), true);
  }, true);

  /* Clic sur un coloris : on va directement sur la fiche de ce coloris (un seul clic) */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest && e.target.closest('.mb-card .color-swatch[href]');
    if (!sw) return;
    e.preventDefault();
    e.stopPropagation();
    window.location.href = sw.getAttribute('href');
  }, true);

  /* Préchargement des photos dès que la souris arrive sur la carte (sans toucher à l'affichage) */
  document.addEventListener('mouseover', function (e) {
    var card = e.target.closest && e.target.closest('.mb-card[data-mb-images]');
    if (!card || card.mbPreloaded) return;
    card.mbPreloaded = true;
    images(card).forEach(function (src) { var i = new Image(); i.src = src; });
  });

  /* Survol d'un coloris : on rend la main à la photo principale pour l'aperçu du coloris */
  document.addEventListener('mouseover', function (e) {
    var sw = e.target.closest && e.target.closest('.mb-card .color-swatch');
    if (!sw) return;
    var card = sw.closest('.mb-card');
    if (card) reset(card);
  });

  /* La souris quitte la carte : retour à la 1re photo */
  document.addEventListener('mouseout', function (e) {
    var card = e.target.closest && e.target.closest('.mb-card[data-mb-images]');
    if (!card) return;
    if (e.relatedTarget && card.contains(e.relatedTarget)) return;
    reset(card);
  });

  /* Mobile : balayer la photo */
  var sx = null, sy = null, scard = null;
  document.addEventListener('touchstart', function (e) {
    var card = e.target.closest && e.target.closest('.mb-card[data-mb-images]');
    if (!card || e.target.closest('.color-swatch')) { scard = null; return; }
    scard = card; sx = e.touches[0].clientX; sy = e.touches[0].clientY;
  }, { passive: true });
  document.addEventListener('touchend', function (e) {
    if (!scard) return;
    var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
      var card = scard;
      var from = card.hasAttribute('data-mb-active') ? current(card) : 0;
      if (!card.hasAttribute('data-mb-active')) go(card, from, false);
      go(card, from + (dx < 0 ? 1 : -1), true);
      var link = card.querySelector('.product-card__media');
      if (link) {
        var block = function (ev) { ev.preventDefault(); link.removeEventListener('click', block, true); };
        link.addEventListener('click', block, true);
        setTimeout(function () { link.removeEventListener('click', block, true); }, 400);
      }
    }
    scard = null;
  }, { passive: true });
})();

/* MY BOB — fiche produit : défilement des coloris (flèches) */
(function () {
  'use strict';
  function update(wrap) {
    var sc = wrap.querySelector('.mb-cs-scroller');
    if (!sc) return;
    var prev = wrap.querySelector('.mb-cs-arrow--prev'), next = wrap.querySelector('.mb-cs-arrow--next');
    if (prev) prev.disabled = sc.scrollLeft <= 2;
    if (next) next.disabled = sc.scrollLeft + sc.clientWidth >= sc.scrollWidth - 2;
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.mb-cs-arrow');
    if (!btn) return;
    e.preventDefault();
    var wrap = btn.closest('.mb-cs-wrap');
    var sc = wrap && wrap.querySelector('.mb-cs-scroller');
    if (!sc) return;
    var step = sc.clientWidth;
    sc.scrollBy({ left: btn.classList.contains('mb-cs-arrow--prev') ? -step : step, behavior: 'smooth' });
  });
  document.addEventListener('scroll', function (e) {
    var sc = e.target;
    if (sc && sc.classList && sc.classList.contains('mb-cs-scroller')) update(sc.closest('.mb-cs-wrap'));
  }, true);
  function init() { document.querySelectorAll('.mb-cs-wrap').forEach(update); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('resize', init);
  document.addEventListener('shopify:section:load', init);
})();

/* MY BOB — fiche produit : le texte défile avec les photos, puis reste fixé quand on arrive à sa fin */
(function () {
  'use strict';
  var GAP = 20;
  function headerOffset() {
    var h = document.querySelector('.shopify-section--header');
    if (!h) return 0;
    var cs = getComputedStyle(h);
    return (cs.position === 'sticky' || cs.position === 'fixed') ? h.getBoundingClientRect().height : 0;
  }
  function apply(el) {
    if (window.innerWidth < 1000) { el.style.removeProperty('--mb-info-top'); el.removeAttribute('data-mb-sticky'); return; }
    var top = headerOffset() + GAP;
    var fit = window.innerHeight - el.offsetHeight - GAP;
    el.setAttribute('data-mb-sticky', '');
    el.style.setProperty('--mb-info-top', Math.min(top, fit) + 'px');
  }
  function init() {
    document.querySelectorAll('.product-info').forEach(function (el) {
      if (el.closest('.quick-buy-modal')) return;
      apply(el);
      if (!el.mbObserved && 'ResizeObserver' in window) {
        el.mbObserved = true;
        new ResizeObserver(function () { apply(el); }).observe(el);
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', init);
  window.addEventListener('resize', init);
  document.addEventListener('shopify:section:load', init);
})();
